import { Eleccion } from '../../types/elecciones'
import { Lista } from '../../types/listas'

export type TListasAnteriores = '7' | '8' | '9' | '10'
const ListasAnteriores = {
  10: {
    color: '#A8A8A8',
    name: 'Otros',
    order: 10,
    parties: [],
  },
  7: {
    color: '#7FCAAD',
    name: 'Lista del Pueblo',
    order: 7,
    parties: [],
  },
  8: {
    color: '#6F449A',
    name: 'Nueva Constitución',
    order: 8,
    parties: [],
  },
  9: {
    color: '#D964A7',
    name: 'Pueblos Originarios',
    order: 9,
    parties: [],
  },
}

export type IResultadosEleccion = {
  [lista in Lista | TListasAnteriores]: number
}

export interface IEleccion {
  eleccion: Eleccion
  resultados: IResultadosEleccion
}

export default ListasAnteriores
